import { basePost, noTokenGet } from "./base";

// 发送短信验证码
export const sendSmsCode = (data?: any) => basePost('/user/send-code', data);
// 登录
export const login = (data?: any) => basePost('/user/login', data);
// 绑定手机
export const bindPhone = (data?: any) => basePost('/user/bind-phone', data);
// 获取登录状态
export const getLoginStatus = (data?: any, options?: { silent?: boolean, skipAuthLogin?: boolean }) => basePost('/user/is-login', data, options);
// 查询创角:根据游戏项目是否开启
export const getRolesApi = (data?: any) => basePost('/user/get-role', data);
// 生成令牌
export const getTokenApi = (data?: any) => basePost('/user/get-token', data);
// 获取抖音授权游戏
export const getDyGame = (data?: any) => basePost('/user/get-game', data);
// 抖音授权
export const getThirdAuth = (data?: any) => basePost('/user/third-auth', data);

// 是否第一次弹窗
export const isPopUp = (data?: any) => basePost('/work-order/is-popUp', data);

// webJs授权
export const webjs = (data?: any) => basePost('/user/web-js', data);

// 获取消息未读标识
export const getMsgState = (data?: any, options?: { silent?: boolean }) => basePost('/work-order/get-message-state', data, options);

// 工单点击
export const workRead = (data?: any) => basePost('/work-order/read', data);

// 工单追问
export const workProbe = (data?: any) => basePost('/work-order/probe', data);

// 初始化，下发ucCode
export const init = () => basePost('/user/init');

// 检测ticket是否有效,下发jwt
export const checkTicket = (params?: any) => noTokenGet('/user/get-jwt', params);